import { InstanceData } from "../models/shared/InstanceData";
import { FUNCTIONS } from "./config";
import { convertData } from "./shared/firebase";


interface InstanceDataResponse {
    instanceData: Partial<InstanceData>
    token: string
}
export const getInstanceData = async (): Promise<InstanceDataResponse> => {
    const instance = getQueryParam('instance');
    const endpoint = `${FUNCTIONS.getInstanceData}?instance=${instance}`;

    const result = await fetch(endpoint);

    return convertData(await result.json());
}


const getQueryParam = (name: 'instance' | 'compId' | 'viewMode' | 'origCompId') => {
    const queryParamValue = new URLSearchParams(window.location.search).get(name);
    if (!queryParamValue) {
        throw new Error(`client:No ${name} query param`);
    }
    return queryParamValue;
}


